module.exports = __webpack_public_path__ + "static/media/MGEM_logo.556e051d.jpg";